module.exports = __webpack_public_path__ + "static/img/TEMIDAYO.a2d378b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/TEMIDAYO.png
// module id = H4a6
// module chunks = 0